import Error403 from 'pages/Error/Error403';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

const withAccessControl = (WrappedComponent: React.FC, privilege: string): React.FC => {
    return (props: any) => {

        const privileges = useSelector((state: RootState) => state.auth.privileges);

        if (!privileges.includes(privilege)) {
            return <Error403 />
        }

        return <WrappedComponent {...props} />;
    };
};

export default withAccessControl;